import { gql } from 'apollo-angular';

const VALIDATE_EMAIL = gql`
  query validateEmail($emailAddress: String) {
    validateEmail(emailAddress: $emailAddress) {
      id
    }
  }
`;

export default VALIDATE_EMAIL;
